export const getFormattedPhone = (value: string | null | undefined): string => {
    var returnString = value ?? "";
    if (returnString === null || returnString === undefined) {
        return "";
    } else if (returnString.length === 10) {
        return returnString.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }

    return returnString;
}